import React, { useState } from 'react'
import { FloorMapSpaces } from '@api'
import { Flex } from '@ui'
import { IDonutData } from '@ui/charts/Donut'
import ChartSection from 'components/ChartSection'
import { get, groupBy, keys } from 'lodash'
import { Button } from '@runeffective/evo-design-system'
import WorkplaceGroupPopup from './workplaceGroupPopup'
import ReallocateAllPopup from './reallocateAllPopup'

const formatData = (spaces: any, selectedItems: string[]) => {
  const { byId } = spaces
  const items = selectedItems.reduce(
    (result: any, id: string) => (byId[id] ? [...result, byId[id]] : result),
    []
  )
  const grouped = groupBy(items, ({ spaceAssignment }) => {
    if (spaceAssignment?.team) {
      return spaceAssignment.team.id
    }

    if (spaceAssignment?.department) {
      return spaceAssignment.department.id
    }

    return 'Unallocated'
  })

  const data = keys(grouped)
    .sort((k1, k2) => grouped[k2].length - grouped[k1].length)
    .reduce((result: IDonutData[], key, i) => {
      if (key === 'Unallocated') {
        return result
      }

      return [
        ...result,
        {
          key,
          label: get(
            grouped[key][0],
            'spaceAssignment.team.name',
            get(grouped[key][0], 'spaceAssignment.department.name')
          ),
          color: `#${get(
            grouped[key][0],
            'spaceAssignment.team.color',
            get(grouped[key][0], 'spaceAssignment.department.color')
          )}`,
          value: grouped[key].length,
        },
      ]
    }, [])

  if (grouped.Unallocated) {
    return [
      ...data,
      {
        key: 'Unallocated',
        label: 'Unallocated',
        color: '#333',
        value: grouped.Unallocated.length,
      },
    ]
  }

  return data
}

const AllocationSection = ({
  spaces,
  selectedItems,
  allEmployeesList,
}: {
  spaces: FloorMapSpaces
  selectedItems: string[]
  allEmployeesList: string[]
}) => {
  const chartData = formatData(spaces, selectedItems)
  const [isWorkplaceGroupOpen, setIsWorkplaceGroupOpen] = useState(false)
  const [isReallocateAllOpen, setIsReallocateAllOpen] = useState(false)

  return (
    <div style={{ margin: '10px' }}>
      <ChartSection chartType="donut" colName="" description="" data={chartData} />
      <Flex style={{ width: '100%', margin: '5px' }} direction="row" justify="space-between">
        <Button
          layout="secondary"
          onClick={() => {
            setIsReallocateAllOpen(true)
          }}
          size="small">
          Reallocate All
        </Button>
        <Button
          layout="secondary"
          onClick={() => {
            setIsWorkplaceGroupOpen(true)
          }}
          size="small">
          Workplace groups
        </Button>
      </Flex>
      <WorkplaceGroupPopup
        isWorkplaceGroupOpen={isWorkplaceGroupOpen}
        setIsWorkplaceGroupOpen={setIsWorkplaceGroupOpen}
        selectedSpaces={selectedItems}
        allEmployeesList={allEmployeesList}
      />

      <ReallocateAllPopup
        isReallocateAllOpen={isReallocateAllOpen}
        setIsReallocateAllOpen={setIsReallocateAllOpen}
        selectedSpaces={selectedItems}
      />
    </div>
  )
}

export default AllocationSection
